import { Dayjs } from 'dayjs';
import { AccessFilterAction } from 'v2/utils/accessEvents';

export const FilterEventDetail = {
  NoToken: 'NO_TOKEN',
  DomUnknown: 'DOM_UNKNOWN'
} as const;

export type FilterEventDetailValue = (typeof FilterEventDetail)[keyof typeof FilterEventDetail];

export type FilterEventDetailState = FilterEventDetailValue | null;

export interface EventsFilter {
  access: AccessFilterAction | null;
  detail: FilterEventDetailState;
  dateStart: Dayjs | null;
  dateEnd: Dayjs | null;
  user: string | null;
  device: string | null;
}

export interface EventsFilterSetters {
  setFilterAccess: (value: AccessFilterAction | null) => void;
  toggleFilterAccess: (value: AccessFilterAction) => void;
  setFilterDetail: (value: FilterEventDetailState) => void;
  setFilterDateStart: (value: Dayjs | null) => void;
  setFilterDateEnd: (value: Dayjs | null) => void;
  clearFilterDates: () => void;
  setFilterUser: (value: string | null) => void;
  setFilterDevice: (value: string | null) => void;
}

export interface EventsFilterState {
  filter: EventsFilter;
  setters: EventsFilterSetters;
  clearAllFilters: () => void;
  isAnyFilterEnabled: boolean;
}
